import { useMemo } from "react";
import { AppFeature } from "../components/AppContext";
import { venueToCardStyle } from "../utils/venue-style-mapping";

export const useVenueStyle = (venue: AppFeature) => {
    return useMemo(() => {
        return venueToCardStyle(venue)
    }, [venue])
}